const selectProjectCreatedIsOpen = (state) => state.modals.projectCreated.isOpen;

const selectProjectCreatedData = (state) => state.modals.projectCreated.data || {};

const selectUnsuitableWriterIsOpen = (state) => state.modals.unsuitableWriter.isOpen;

const selectExistingUserIsOpen = (state) => state.modals.existingUser.isOpen;

const selectUnableToUpdateRole = (state) => state.modals.unableToUpdateRole.isOpen;

const selectThankYouForApprovingDraft = (state) => state.modals.thankYouForApprovingDraft.isOpen;

const selectWriterConfirmedOnProject = (state) => state.modals.writerConfirmedOnProject.isOpen;

const selectWriterConfirmedOnProjectData = (state) => state.modals.writerConfirmedOnProject.data || {};

const selectSendToPrinterIsOpen = (state) => state.modals.sendToPrinter.isOpen;

const selectSuccessfullySentToPrinterIsOpen = (state) => state.modals.successfullySentToPrinter.isOpen;

const selectScheduleInterviewIsOpen = (state) => state.modals.scheduleInterview.isOpen;

const selectEditorFeedbackToWriterIsOpen = (state) => state.modals.editorFeedbackToWriter.isOpen;

const selectDraftIsUpdatedByWriterIsOpen = (state) => state.modals.draftIsUpdatedByWriter.isOpen;

const selectDraftEditedByCustomerIsOpen = (state) => state.modals.draftEditedByCustomer.isOpen;

const selectCompleteInterviewIsOpen = (state) => state.modals.completeInterview.isOpen;

const selectCancelInterviewIsOpen = (state) => state.modals.cancelInterview.isOpen;

const selectConfirmInterviewIsOpen = (state) => state.modals.confirmInterview.isOpen;

const selectEditInterviewNoteIsOpen = (state) => state.modals.editInterviewNote.isOpen;

const selectCustomerOutlineOnboardingIsOpen = (state) => state.modals.customerOutlineOnboarding.isOpen;

const selectOutlineSubmittedIsOpen = (state) => state.modals.outlineSubmitted.isOpen;

const selectThankYouForApprovingOutlineIsOpen = (state) => state.modals.thankYouForApprovingOutline.isOpen;

const selectProofApprovedByCustomerIsOpen = (state) => state.modals.proofApprovedByCustomer.isOpen;

const selectProofApprovedByEditorIsOpen = (state) => state.modals.proofApprovedByEditor.isOpen;

const selectRedirectToRateWriterIsOpen = (state) => state.modals.redirectToRateWriter.isOpen;

const selectRateUserIsOpen = (state) => state.modals.rateUser.isOpen;

const selectFirstInterviewScheduledIsOpen = (state) => state.modals.firstInterviewScheduled.isOpen;

const selectOnboardingModalIsOpen = (state) => state.modals.onboarding.isOpen;

const selectDraftApprovedByCustomerIsOpen = (state) => state.modals.draftApprovedByCustomer.isOpen;

const selectDraftApprovedByWriterIsOpen = (state) => state.modals.draftApprovedByWriter.isOpen;

const selectDraftApprovedByEditorIsOpen = (state) => state.modals.draftApprovedByEditor.isOpen;

const selectRateOutlineIsOpen = (state) => state.modals.rateOutline.isOpen;

const selectRateBookOutlineIsOpen = (state) => state.modals.rateBookOutline.isOpen;

const selectRateDraftIsOpen = (state) => state.modals.rateDraft.isOpen;

const selectDeleteCoverPhotosIsOpen = (state) => state.modals.deleteCoverPhotos.isOpen;

const selectUseTimelineModalIsOpen = (state) => state.modals.useTimeline.isOpen;

const selectCoverNotificationIsOpen = (state) => state.modals.coverNotification.isOpen;

const selectHubspotModalIsOpen = (state) => state.modals.hubspot.isOpen;

const selectUpgradeRequestedModalIsOpen = (state) => state.modals.upgradeRequestedModal.isOpen;

const selectPackageUpgradeRequestModalIsOpen = (state) => state.modals.packageUpgradeRequest.isOpen;

const selectUpgradeRequestCompletedModalIsOpen = (state) => state.modals.upgradeRequestCompleted.isOpen;

const selectActiveSubscriptionWarnModalIsOpen = (state) => state.modals.activeSubscriptionWarn.isOpen;

const selectQuestionnaireSentModalIsOpen = (state) => state.modals.questionnaireSent.isOpen;

const selectRateWriterByDevelopmentalEditorIsOpen = (state) => state.modals.rateWriterByDevelopmentalEditor.isOpen;

const selectRateProofByCustomerModalIsOpen = (state) => state.modals.rateProofByCustomer.isOpen;

const selectOnboardingFeedbackIsOpen = (state) => state.modals.onboardingFeedback.isOpen;

const selectConfirmSampleApprovalModalIsOpen = (state) => state.modals.confirmSampleApproval.isOpen;

const selectThankYouForApprovingSampleIsOpen = (state) => state.modals.thankYouForApprovingSample.isOpen;

const selectChatBotInfoModalIsOpen = (state) => state.modals.chatbotInfo.isOpen;

const selectThankYouForStyleSampleApprovalIsOpen = (state) => state.modals.thankYouForApprovingStyleSample.isOpen;

const selectExtensionFeePaymentModalIsOpen = (state) => state.modals.extensionFeePayment.isOpen;

const selectCustomerAccessToProjectBlockedModalIsOpen = (state) => state.modals.customerAccessToProjectBlocked.isOpen;

const selectAccessToProjectBlockedModalIsOpen = (state) => state.modals.accessToProjectBlocked.isOpen;

const selectRateByWriterIsOpen = (state) => state.modals.rateByWriter.isOpen;

const selectTranscribeFileModalIsOpen = (state) => state.modals.transcribeAudioFile.isOpen;

const selectRestoreVersionIsOpen = (state) => state.modals.restoreVersion.isOpen;

const selectEditorProofNotReadyIsOpen = (state) => state.modals.editorProofNotReady.isOpen;

const selectNoAddressForCustomerModalIsOpen = (state) => state.modals.noAddressForCustomer.isOpen;

const selectRequestReviewIsOpen = (state) => state.modals.requestReview.isOpen;

export default {
  selectProjectCreatedIsOpen,
  selectProjectCreatedData,
  selectUnsuitableWriterIsOpen,
  selectExistingUserIsOpen,
  selectUnableToUpdateRole,
  selectThankYouForApprovingDraft,
  selectWriterConfirmedOnProject,
  selectWriterConfirmedOnProjectData,
  selectSendToPrinterIsOpen,
  selectSuccessfullySentToPrinterIsOpen,
  selectScheduleInterviewIsOpen,
  selectEditorFeedbackToWriterIsOpen,
  selectDraftIsUpdatedByWriterIsOpen,
  selectDraftEditedByCustomerIsOpen,
  selectCompleteInterviewIsOpen,
  selectCancelInterviewIsOpen,
  selectConfirmInterviewIsOpen,
  selectEditInterviewNoteIsOpen,
  selectCustomerOutlineOnboardingIsOpen,
  selectOutlineSubmittedIsOpen,
  selectThankYouForApprovingOutlineIsOpen,
  selectProofApprovedByCustomerIsOpen,
  selectProofApprovedByEditorIsOpen,
  selectRedirectToRateWriterIsOpen,
  selectRateUserIsOpen,
  selectFirstInterviewScheduledIsOpen,
  selectOnboardingModalIsOpen,
  selectDraftApprovedByCustomerIsOpen,
  selectDraftApprovedByWriterIsOpen,
  selectDraftApprovedByEditorIsOpen,
  selectRateDraftIsOpen,
  selectDeleteCoverPhotosIsOpen,
  selectUseTimelineModalIsOpen,
  selectCoverNotificationIsOpen,
  selectHubspotModalIsOpen,
  selectUpgradeRequestedModalIsOpen,
  selectPackageUpgradeRequestModalIsOpen,
  selectUpgradeRequestCompletedModalIsOpen,
  selectActiveSubscriptionWarnModalIsOpen,
  selectQuestionnaireSentModalIsOpen,
  selectRateWriterByDevelopmentalEditorIsOpen,
  selectRateProofByCustomerModalIsOpen,
  selectOnboardingFeedbackIsOpen,
  selectConfirmSampleApprovalModalIsOpen,
  selectThankYouForApprovingSampleIsOpen,
  selectRateOutlineIsOpen,
  selectRateBookOutlineIsOpen,
  selectChatBotInfoModalIsOpen,
  selectThankYouForStyleSampleApprovalIsOpen,
  selectExtensionFeePaymentModalIsOpen,
  selectCustomerAccessToProjectBlockedModalIsOpen,
  selectAccessToProjectBlockedModalIsOpen,
  selectRateByWriterIsOpen,
  selectTranscribeFileModalIsOpen,
  selectRestoreVersionIsOpen,
  selectEditorProofNotReadyIsOpen,
  selectNoAddressForCustomerModalIsOpen,
  selectRequestReviewIsOpen,
};
